<!--
FG - FOOF - After Cert - First Release (7) - First Release Security 
  I added this template to display when a user doesn't have rights to even display a page
-->
<template>
  <div style="background-color:rgba(0,0,0,0.4);">
    <h3 style="margin-top:10%;padding:30px;color:white">
      <center>
        <span v-if="!text">You do not have access to the page you requested</span>
        <span v-if="text">You do not have access to the page: {{text}}</span>
      </center>
    </h3>
  </div>
</template>
<script>
export default {
    props: ['text'],
    methods: {
    }
  }
</script> 


// WEBPACK FOOTER //
// hydroware-access-to-page-denied.vue?b84140e0